import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ImageUploadProps {
  onImagesUploaded: (paths: string[]) => void;
}

const ImageUpload = ({ onImagesUploaded }: ImageUploadProps) => {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    
    setUploading(true);
    const files = Array.from(e.target.files);
    const imagePaths: string[] = [];

    try {
      for (const file of files) {
        const fileExt = file.name.split('.').pop();
        const fileName = `${Math.random()}.${fileExt}`;

        const { data, error } = await supabase.storage
          .from('parking-spots')
          .upload(fileName, file);

        if (error) throw error;
        if (data) imagePaths.push(data.path);
      }

      onImagesUploaded(imagePaths);
    } catch (error: any) {
      console.error('Error uploading images:', error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <Label htmlFor="images">Upload Images</Label>
      <Input
        id="images"
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        disabled={uploading}
      />
      {uploading && <p className="text-sm text-gray-500">Uploading...</p>}
    </div>
  );
};

export default ImageUpload;